import './App.css';
//Componenets
import Footer from './components/Footer';
import Navbar from './components/Navbar';
//Pages
import Home from './pages/Home'
import Products from './pages/Products';
import Product from './pages/Product.xxxjs';
import Card from './pages/Card';
import OrderSummary from './pages/OrderSummary';
import NotFound from './pages/NotFound';
import ProductDetail from './pages/ProductDetail';
import Test from './pages/Test';
//other
import {Routes,Route} from 'react-router-dom';
// import { ProductProvider } from './context/ProductsContext';


const App = () => {
  return (
    <div className="App">
        {/* <ProductProvider> */}
    <Navbar/>
    <Routes>
      <Route path='/' element={<Home/>} />
      <Route path='/products' element={<Products/>} />
      {/* <Route path='/single1/' element={<Product />} /> */}
      <Route path='/card/' element={<Card />} />

      <Route path='/ordersummary' element={<OrderSummary/>} />
      <Route path='/*' element={<NotFound/>} />
      {/* <Route path="/product/:id" element={<ProductDetail />} /> */}
      {/* <Route path="/product/" element={<ProductDetail />} /> */}
      <Route path="/product/:id" element={<ProductDetail />} />
      <Route path="/test/" element={<Test />} />

    </Routes>
  <Footer/>
  {/* </ProductProvider> */}
      
    </div>
  );
}

export default App;
